<template>
  <div class="reportYear">
    <header>
      <!-- <el-form ref="searchForm" slot="search-form" :model="searchForm" inline>
        <el-form-item prop="code" label="公众号">
          <el-input v-model="searchForm.name" placeholder="请输入关键字" />
        </el-form-item>
        <el-form-item prop="status" label="主体">
          <el-select placeholder="全部" />
        </el-form-item>
        <el-form-item prop="listorder" label="平台">
          <el-select placeholder="全部" />
        </el-form-item>
        <el-form-item prop="listorder" label="书名">
          <el-select placeholder="全部" />
        </el-form-item>
        <el-form-item prop="listorder" label="主角">
          <el-select placeholder="全部" />
        </el-form-item>
        <el-form-item prop="listorder" label="投放者">
          <el-select placeholder="全部" />
        </el-form-item>
        <el-form-item prop="listorder" label="投放组">
          <el-select placeholder="全部" />
        </el-form-item>
        <el-form-item prop="listorder" label="投放版位">
          <el-select placeholder="全部投放版位" />
        </el-form-item>
      </el-form> -->
      <el-card shadow="never" style="padding-top:20px">
        <el-form inline>
          <el-form-item label="公众号">
            <el-input
              v-model="selectQueryData.wechat_account_name"
              placeholder="请输入关键字"
              clearable
            />
          </el-form-item>
          <el-form-item label="平台">
            <el-select
              v-model="selectQueryData.platform_id"
              placeholder="全部"
              filterable
            >
              <el-option
                v-for="item in selectListData.data ? selectListData.data.platform : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="书名">
            <!-- <el-select
              v-model="selectQueryData.novel_id"
              placeholder="全部"
              filterable
            >
              <el-option
                v-for="item in selectListData.data ? selectListData.data.novel : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select> -->
            <el-autocomplete
              v-model="novel_name"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入小说名称"
              @select="handleSelect"
            />
          </el-form-item>
          <el-form-item v-if="displayType === 'list'" label="主角">
            <el-select
              v-model="selectQueryData.lead_id"
              placeholder="全部"
              filterable
            >
              <el-option
                v-for="item in selectListData.data ? selectListData.data.lead : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="投放者">
            <el-select
              v-model="selectQueryData.user_id"
              placeholder="全部"
              filterable
            >
              <el-option
                v-for="item in selectListData.data ? selectListData.data.user : null"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="年份">
            <el-select v-model="selectQueryData.year" placeholder="请选择">
              <el-option
                v-for="item in optionsyear"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="displayType === 'chart'" label="投放平台">
            <el-select v-model="selectQueryData.launch_platform_type" placeholder="请选择">
              <el-option
                v-for="item in optionstoufang"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="年份">
          <el-select placeholder="全部" />
        </el-form-item>
        <el-form-item label="投放版位">
          <el-select placeholder="全部投放版位" />
        </el-form-item> -->
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleSearch"
          >搜索</el-button>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            @click="handleReset"
          >重置</el-button>
        </el-form>

      </el-card>
    </header>
    <main v-if="displayType == 'list'">
      <el-card shadow="never" style="padding-top:20px;margin-top:16px;">
        <div class="titles">
          <div style="margin-right: 20px">上次更新时间为：{{ updateTime === null ? '0000-00-00 00:00:00' : updateTime }}</div>
          <div>
            <label>书城账号密码</label>
            <label>更新数据</label>
            <label>更新月表数据</label>
          </div>
        </div>
        <div class="form">
          <div class="form-top">
            <div class="title" style="font-weight:normal">
              <span>关键指标明细</span>
              <span>（总成本：<span class="blue">{{ data ? data.account_recharge : 0 }}</span></span>
              <span class="aggregateData">总充值：<span class="blue">{{ data ? data.order_money : 0 }}</span></span>
              <span class="aggregateData">总回收率：<span class="blue">{{ data ? data.ycba : 0 }}%</span> ）</span>
              <span style="margin-left: 10px">首付金额</span>
              <el-switch
                v-model="value"
                :width="40"
                active-color="#409EFF"
                inactive-color="rgb(191,191,191)"
                style="margin-left: 10px"
              />
            </div>
            <div class="table-label">
              <span>
                <img src="../../assets/images/13.小说/Wallet.webp">总充</span>
              <span>
                <img src="../../assets/images/13.小说/Trend.webp">总充回本率</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card.webp">首冲回本</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card-two.webp">复充回本</span>
            </div>
          </div>
        </div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          style="width: 100%;font-weight:normal"
        >
          <el-table-column
            fixed
            prop="year"
            label="日期"
            align="center"
            sortable
            :width="103"
          >
            <template slot-scope="scope">
              {{ scope.row.year }}
            </template>
          </el-table-column>
          <el-table-column
            prop="order_money"
            label="累计充值"
            align="center"
            sortable
            :width="103"
          >
            <template slot-scope="scope">
              {{ scope.row.order_money }}
            </template>
          </el-table-column>
          <el-table-column
            prop="account_recharge"
            label="成本"
            align="center"
            sortable
            :width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.account_recharge }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ycba"
            label="回本率"
            align="center"
            :width="108"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.ycba }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="profit"
            label="利润"
            align="center"
            :width="103"
          >
            <template slot-scope="scope">
              {{ scope.row.profit }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in tableData ? tableData[0].data : null"
            :key="index"
            prop="data"
            :label="'第'+(index + 1)+'年'"
            align="center"
            :min-width="100"
          >
            <template slot-scope="scope">
              <div><img
                src="../../assets/images/13.小说/Wallet.webp"
                style="width: 16px;margin-right:5px"
              >{{ scope.row.data[index].zc }}</div>
              <div> <img
                src="../../assets/images/13.小说/Trend.webp"
                style="width: 16px;margin-right:5px"
              >{{ scope.row.data[index].ycb }}</div>
              <div>
                <span><img
                  src="../../assets/images/13.小说/Bank-card.webp"
                  style="width: 16px;margin-right:5px"
                >{{ scope.row.data[index].scb }}</span>
                <el-divider direction="vertical" />
                <span class="yellow"><img
                  src="../../assets/images/13.小说/Bank-card-two.webp"
                  style="width: 16px;margin-right:5px"
                >{{ scope.row.data[index].fcb }}</span>
              </div>
              <div v-show="value">
                <span>{{ scope.row.data[index].sc }}</span>
                <el-divider direction="vertical" />
                <span class="yellow">{{ scope.row.data[index].fc }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <Pagination
          :total="total"
          :page.sync="pageData.page"
          :limit="10"
        /> -->
        <pagination-right
          :total="total"
          :page-sizes="[10]"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </el-card>
    </main>
    <main v-if="displayType == 'chart'">
      <el-card
        shadow="never"
        class="total-box"
        style="padding:20px 0px; margin:16px 0px;"
      >
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <!-- 1. 总成本 -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/chengben.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总成本</div>
              <div>
                <span>￥</span>
                <count-to
                  :key="newdataobj ? newdataobj.account_recharge : 0"
                  :start-val="0"
                  :end-val="newdataobj ? Number(newdataobj.account_recharge) : 0"
                  :duration="1500"
                  :decimals="0"
                />
              </div>
            </div>
          </div>

          <!-- 2. 总充值 -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/chongzhi.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总充值</div>
              <div>
                <span>￥</span>
                <count-to
                  :key="newdataobj ? newdataobj.order_money : 0"
                  :start-val="0"
                  :end-val="newdataobj ? Number(newdataobj.order_money) : 0"
                  :duration="1500"
                  :decimals="0"
                />
              </div>
            </div>
          </div>

          <!-- 3. 总回本率 (百分比，保留2位小数) -->
          <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/huiben.webp"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>总回收率</div>
              <div>
                <!-- <count-to
                  :key="newdataobj ? newdataobj.tcbi : 0"
                  :start-val="0"
                  :end-val="newdataobj ? Number(newdataobj.tcbi) : 0"
                  :duration="1500"
                  :decimals="2"
                /> -->
                <div v-if="newdataobj">
                  {{ newdataobj.tcbi }}
                </div>
                <!-- <span>%</span> -->
              </div>
            </div>
          </div>

          <!-- 4. 增长率 (百分比，保留2位小数) -->
          <!-- <div class="total-cell">
            <div class="total-img">
              <img
                src="../../assets/images/13.小说/zengzhang.png"
                alt=""
              >
            </div>
            <div class="total-data">
              <div>增长率</div>
              <div>
                <count-to
                  :key="data ? data.ir : 0"
                  :start-val="0"
                  :end-val="data ? Number(data.ir) : 0"
                  :duration="1500"
                  :decimals="2"
                />
                <span>%</span>
              </div>
            </div>
          </div> -->
        </div>
      </el-card>
      <el-card shadow="never" style="margin-bottom:16px">
        <div class="form">
          <div class="form-top">
            <div class="title" style="font-weight:normal">
              <span>关键指标明细表</span>
              <span class="aggregateData">总成本：<span class="blue">{{ newdataobj ? newdataobj.account_recharge : 0 }}</span></span>
              <span class="aggregateData">总充值：<span class="blue">{{ newdataobj ? newdataobj.account_recharge : 0 }}</span></span>
              <span class="aggregateData">总回收率：<span class="blue">{{ newdataobj ? newdataobj.account_recharge: 0 }}%</span> ）</span>
            </div>
            <div class="table-label">
              <span>
                <img src="../../assets/images/13.小说/Wallet.webp">总充</span>
              <span>
                <img src="../../assets/images/13.小说/Trend.webp">总充回本率</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card.webp">首冲回本</span>
              <span>
                <img src="../../assets/images/13.小说/Bank-card-two.webp">复充回本</span>
            </div>
          </div>
        </div>
        <el-table
          :data="newdata"
          border
          :cell-style="cellStyle"
          :header-cell-style="headerCellStyle"
          style="width: 100%;font-weight:normal"
        >
          <el-table-column
            fixed
            prop="date"
            label="日期"
            align="center"
            sortable
            :width="103"
          >
            <template slot-scope="scope">
              {{ scope.row.date }}
            </template>
          </el-table-column>
          <el-table-column
            prop="order_money"
            label="累计充值"
            align="center"
            sortable
            :width="103"
          >
            <template slot-scope="scope">
              {{ scope.row.order_money }}
            </template>
          </el-table-column>
          <el-table-column
            prop="account_recharge"
            label="成本"
            align="center"
            sortable
            :width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.account_recharge }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ycba"
            label="回本率"
            align="center"
            :width="108"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.ycba }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="profit"
            label="利润"
            align="center"
            :width="103"
          >
            <template slot-scope="scope">
              {{ scope.row.profit }}
            </template>
          </el-table-column>
          <!-- 动态列 -->
          <el-table-column
            v-for="(item, indexr) in (newdata[0] && newdata[0].data) || []"
            :key="indexr"
            :label="'第' + (indexr + 1) + '年'"
            align="center"
            :min-width="100"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.data && scope.row.data[indexr]">
                <div><img
                  src="../../assets/images/13.小说/Wallet.webp"
                  style="width: 16px;margin-right:5px"
                >{{ scope.row.data[indexr].zc }}</div>
                <div><img
                  src="../../assets/images/13.小说/Trend.webp"
                  style="width: 16px;margin-right:5px"
                >{{ scope.row.data[indexr].tcb }}</div>
                <div>
                  <span><img
                    src="../../assets/images/13.小说/Bank-card.webp"
                    style="width: 16px;margin-right:5px"
                  >{{ scope.row.data[indexr].scb }}</span>
                  <el-divider direction="vertical" />
                  <span class="yellow"><img
                    src="../../assets/images/13.小说/Bank-card-two.webp"
                    style="width: 16px;margin-right:5px"
                  >{{ scope.row.data[indexr].fcb }}</span>
                </div>
                <div v-if="value">
                  <span>{{ scope.row.data[indexr].sc }}</span>
                  <el-divider direction="vertical" />
                  <span class="yellow">{{ scope.row.data[indexr].fc }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          :total="newcount"
          :page-sizes="[10]"
          @size-change="fetchPageSizer"
          @current-change="fetchCurrentPager"
        />
      </el-card>
      <!-- 图表容器 （示例4个） -->
      <div class="chart-layout">
        <div ref="chart1" class="chart-item" />
        <div ref="chart2" class="chart-item" />
        <div ref="chart3" class="chart-item" />
        <div ref="chart4" class="chart-item" />
        <!-- <div style="width: 100%;text-align: right;margin-bottom: 20px;">
          <el-select v-model="monthIndex" placeholder="请选择" @change="sewqawr">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div> -->
        <div ref="chart5" class="chart-item" />
        <div ref="chart6" class="chart-item" />
      </div>
    </main>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight'
// import Pagination from '@/components/Pagination'
import { getList } from '@/api/report/reportYear'
import { getSelectList } from '@/api/report/SelectData.js'
import { predityearv2, predityeargraphics } from '@/api/releaseGroup.js'
import * as echarts from 'echarts'
import CountTo from 'vue-count-to'
import dialogFocus from '@/layout/mixin/dialogFocus'
import { getFictionList, commonreportoptions } from '@/api/copyReleaseGroup.js'
export default {
  name: 'ReportYear',
  components: { PaginationRight, CountTo },
  mixins: [dialogFocus],
  props: {
    displayType: {
      type: String,
      default: 'list'
    }
  },
  data() {
    const currentYear = new Date().getFullYear()
    return {
      total: 0,
      selectListData: [], // 筛选列表数据
      selectQueryData: { // 请求数据
        wechat_account_name: null,
        platform_id: null,
        novel_id: null,
        lead_id: null,
        user_id: null,
        page: 1,
        year: new Date().getFullYear(),
        launch_platform_type: ''
      },
      updateTime: null,
      value: false,
      loading: false,
      searchForm: [],
      tableData: null,
      data: null,
      newdata: [],
      newcount: null,
      newdataobj: null,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      chart5: null,
      chart6: null,
      optionsyear: Array.from({ length: 10 }, (_, i) => {
        const year = currentYear - i
        return {
          value: year,
          label: `${year}年`
        }
      }),
      optionstoufang: [],
      novel_name: null
    }
  },
  watch: {
    displayType(newVal, oldVal) {
      console.log('displayType changed from', oldVal, 'to', newVal)
      // 根据需要执行的逻辑
      // eslint-disable-next-line eqeqeq
      if (newVal == 'chart') {
        this.selectQueryData.page = 1
        this.newlist()
        this.newtubiao()
      } else {
        this.selectQueryData.page = 1
        this.disposeAllCharts()
        this.getList()
      }
    }
  },
  created() {
    this.getSelectListData()
    this.oplistr()
    // this.getList()
  },
  methods: {
    // 获取筛选列表
    getSelectListData() {
      getSelectList().then(res => {
        this.selectListData = res
      })
    },
    getList() {
      this.loading = true
      getList(this.selectQueryData)
        .then(response => {
          this.tableData = response.data.list
          this.total = response.data.page_info.total
          this.page = response.data.page_info.page
          this.page_size = response.data.page_info.page_size
          this.updateTime = response.data.last_modify_time
          this.data = this.tableData[0]
          this.loading = false
        })
    },
    fetchPageSize(e) {
      // console.log(e)
    },
    fetchCurrentPage(e) {
      this.selectQueryData.page = e
      this.getList()
    },
    fetchPageSizer(e) {
      console.log(e)
    },
    fetchCurrentPager(e) {
      this.selectQueryData.page = e
      this.newlist()
    },
    // 搜索按钮
    handleSearch() {
      this.selectQueryData.page = 1
      // console.log('search', this.selectQueryData)
      // this.getList()
      // eslint-disable-next-line eqeqeq
      if (this.displayType == 'list') {
        this.getList()
      } else {
        this.newlist()
        setTimeout(() => {
          this.newtubiao()
        }, 1000)
      }
    },
    // 重置按钮
    handleReset() {
      this.selectQueryData = {
        wechat_account_name: null,
        platform_id: null,
        novel_id: null,
        lead_id: null,
        user_id: null,
        page: 1,
        year: new Date().getFullYear(),
        launch_platform_type: ''
      }
      this.novel_name = null
      // eslint-disable-next-line eqeqeq
      if (this.displayType == 'list') {
        this.getList()
      } else {
        this.newlist()
        setTimeout(() => {
          this.newtubiao()
        }, 1000)
      }
    },
    allday() {
      // eslint-disable-next-line eqeqeq
      if (this.displayType == 'list') {
        this.getList()
      } else {
        this.newlist()
        setTimeout(() => {
          this.newtubiao()
        }, 1000)
      }
    },
    newlist() {
      predityearv2(this.selectQueryData).then((res) => {
        console.log('数据', res)
        this.newdata = res.data.list
        this.newcount = res.data.count
        this.newdataobj = res.data.list[0]
      })
    },
    newtubiao() {
      predityeargraphics({ ...this.selectQueryData }).then((res) => {
        console.log('年图表', res)
        this.disposeAllCharts()

        this.$nextTick(() => {
          // 图1: 累计充值（元）
          if (this.$refs.chart1) {
            console.log('this.$refs.chart1', this.$refs.chart1)
            this.chart1 = echarts.init(this.$refs.chart1)
            this.chart1.setOption(this.getRechargeOptionr(res.data.data.total_cumulative_recharge))
          }

          // 图2: 成本（元）
          if (this.$refs.chart2) {
            this.chart2 = echarts.init(this.$refs.chart2)
            this.chart2.setOption(this.getCostOptionuser(res.data.data.account_recharge))
          }

          // 图3: 利润（元）
          if (this.$refs.chart3) {
            this.chart3 = echarts.init(this.$refs.chart3)
            this.chart3.setOption(this.getProfitOptionr(res.data.data.profitability))
          }

          // 图4: 回本率（%）
          if (this.$refs.chart4) {
            this.chart4 = echarts.init(this.$refs.chart4)
            this.chart4.setOption(this.getRateOptionrlu(res.data.data.rate_of_return))
          }
          // 图4: 回本率（%）
          // if (this.$refs.chart5) {
          //   this.chart5 = echarts.init(this.$refs.chart5)
          //   // month 为数字，比如 7
          //   const option = this.getMonthlyChartOptionda(this.monthIndex, res.data.data)
          //   this.chart5.setOption(option)
          // }
          if (this.$refs.chart5) {
            this.chart5 = echarts.init(this.$refs.chart5)
            this.chart5.setOption(this.getfivechatoption(res.data.data.order_money_year[0]))
          }
          if (this.$refs.chart6) {
            this.chart6 = echarts.init(this.$refs.chart6)
            this.chart6.setOption(this.getReturnRateOption(res.data.data.rate_of_return_year[0], res.data.data.sc_rate_of_return_year[0], res.data.data.fc_rate_of_return_year[0]))
          }
        })
      })
    },
    disposeAllCharts() {
      if (this.chart1) {
        this.chart1.dispose()
        this.chart1 = null
      }
      if (this.chart2) {
        this.chart2.dispose()
        this.chart2 = null
      }
      if (this.chart3) {
        this.chart3.dispose()
        this.chart3 = null
      }
      if (this.chart4) {
        this.chart4.dispose()
        this.chart4 = null
      }
      if (this.chart5) {
        this.chart5.dispose()
        this.chart5 = null
      }
      if (this.chart6) {
        this.chart6.dispose()
        this.chart6 = null
      }
      window.removeEventListener('resize', this.handleResize)
    },
    handleResize() {
      this.chart1 && this.chart1.resize()
      this.chart2 && this.chart2.resize()
      this.chart3 && this.chart3.resize()
      this.chart4 && this.chart4.resize()
      this.chart5 && this.chart5.resize()
      this.chart6 && this.chart6.resize()
    },
    getRechargeOptionr(total_cumulative_recharge) {
      const xData = total_cumulative_recharge.map(item => item.name)
      const yData = total_cumulative_recharge.map(item => Number(item.value)) // 转为数字

      return {
        title: { text: '累计充值（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '充值',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}元'
              show: false
            }
          }
        ]
      }
    },
    getCostOptionuser(account_recharge) {
      const xData = account_recharge.map(item => item.name)
      const yData = account_recharge.map(item => Number(item.value)) // 转为数字

      return {
        title: { text: '成本（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '成本',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#5FE1E0'
            },
            itemStyle: {
              color: '#5FE1E0',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(95,225,224,0.4)' },
                  { offset: 1, color: 'rgba(95,225,224,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}元'
              show: false
            }
          }
        ]
      }
    },
    getProfitOptionr(profitability) {
      const xData = profitability.map(item => item.name)
      const yData = profitability.map(item => Number(item.value)) // 字符串转数字

      return {
        title: { text: '利润（元）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '利润',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#5FE1E0'
            },
            itemStyle: {
              color: '#5FE1E0',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(95,225,224,0.4)' },
                  { offset: 1, color: 'rgba(95,225,224,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}元'
              show: false
            }
          }
        ]
      }
    },
    getRateOptionrlu(rate_of_return) {
      const xData = rate_of_return.map(item => item.name)
      const yData = rate_of_return.map(item => parseFloat(item.value)) // 字符串转为数字

      return {
        title: { text: '回本率（%）' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: xData,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            formatter: '{value}%'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E0E0E0'
            }
          }
        },
        grid: {
          left: 40,
          right: 20,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: '回本率',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            data: yData,
            lineStyle: {
              width: 2,
              color: '#008DFF'
            },
            itemStyle: {
              color: '#008DFF',
              borderColor: '#fff',
              borderWidth: 1
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(0,141,255,0.4)' },
                  { offset: 1, color: 'rgba(0,141,255,0)' }
                ],
                false
              )
            },
            label: {
              // show: true,
              // formatter: '{c}%' // 标签加上百分号
              show: false
            }
          }
        ]
      }
    },
    getMonthlyChartOption(monthIndex, chartData = {}) {
      const getMonthKey = (prefix) => `${prefix}${monthIndex}`

      const rechargeData = chartData[getMonthKey('order_money_month')] || []
      const rateData = chartData[getMonthKey('rate_of_return_month')] || []
      const scRateData = chartData[getMonthKey('sc_rate_of_return_month')] || []
      const fcRateData = chartData[getMonthKey('fc_rate_of_return_month')] || []

      // X轴的 name 统一提取
      const xAxisData = rechargeData.map(item => item.name)

      // Y轴数据（处理百分比字符串）
      const format = (arr) => xAxisData.map(name => {
        const item = arr.find(d => d.name === name)
        return item ? parseFloat(item.value.replace('%', '')) : 0
      })

      return {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['充值金额', '充值回本率', '首充回本率', '复充回本率']
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '充值金额',
            type: 'line',
            data: rechargeData.map(item => parseFloat(item.value))
          },
          {
            name: '充值回本率',
            type: 'line',
            data: format(rateData)
          },
          {
            name: '首充回本率',
            type: 'line',
            data: format(scRateData)
          },
          {
            name: '复充回本率',
            type: 'line',
            data: format(fcRateData)
          }
        ]
      }
    },
    getMonthlyChartOptionda(monthIndex, chartData = {}) {
      const getMonthKey = (prefix) => `${prefix}${monthIndex}`

      const rechargeData = chartData[getMonthKey('order_money_month')] || []
      const rateData = chartData[getMonthKey('rate_of_return_month')] || []
      const scRateData = chartData[getMonthKey('sc_rate_of_return_month')] || []
      const fcRateData = chartData[getMonthKey('fc_rate_of_return_month')] || []

      const xAxisData = rechargeData.map(item => item.name)

      const formatPercent = (arr) =>
        xAxisData.map(name => {
          const item = arr.find(d => d.name === name)
          return item ? parseFloat(item.value.replace('%', '')) : 0
        })

      return {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let str = `${params[0].axisValue}<br/>`
            params.forEach(item => {
              const isRate = item.seriesName.includes('回本率')
              str += `${item.marker} ${item.seriesName}: ${item.data.toFixed(2)}${isRate ? '%' : ''}<br/>`
            })
            return str
          }
        },
        legend: {
          top: 10,
          data: ['充值金额', '充值回本率', '首充回本率', '复充回本率']
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLine: { lineStyle: { color: '#ccc' }}
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '充值金额',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#FF7C2E' },
            data: rechargeData.map(item => parseFloat(item.value))
          },
          {
            name: '充值回本率',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#FFB500' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFB500' },
                { offset: 1, color: 'rgba(255, 181, 0, 0)' }
              ])
            },
            data: formatPercent(rateData)
          },
          {
            name: '首充回本率',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#45D1D1' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#45D1D1' },
                { offset: 1, color: 'rgba(69, 209, 209, 0)' }
              ])
            },
            data: formatPercent(scRateData)
          },
          {
            name: '复充回本率',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#1D79FB' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#1D79FB' },
                { offset: 1, color: 'rgba(29, 121, 251, 0)' }
              ])
            },
            data: formatPercent(fcRateData)
          }
        ]
      }
    },
    getfivechatoption(order_money_year) {
      const xData = order_money_year.map(item => item.name)
      const yData = order_money_year.map(item => item.value)

      return {
        title: {
          text: '动态年视图'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xData,
          axisTick: { alignWithLabel: true }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '充值',
            type: 'bar',
            data: yData,
            barWidth: '50%',
            itemStyle: {
              barBorderRadius: [7, 7, 0, 0],
              borderRadius: [7, 7, 0, 0],
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: '#008DFF' }, // 顶部
                  { offset: 1, color: 'rgba(0,141,255,0.5)' } // 底部
                ]
              }
            }
          }
        ]
      }
    },

    getReturnRateOption(rateArr = [], scRateArr = [], fcRateArr = []) {
      const names = rateArr.map(item => item?.name)
      const toNums = (arr) => arr.map(item => {
        const v = parseFloat(item?.value)
        return Number.isFinite(v) ? v : 0
      })
      const y1 = toNums(rateArr) // 当日充值回本率
      const y2 = toNums(scRateArr) // 首充回本
      const y3 = toNums(fcRateArr) // 复充回本

      const gradientFrom = (rgba) => ({
        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
        colorStops: [
          { offset: 0, color: rgba }, // 顶部不透明
          { offset: 1, color: rgba.replace(/,?\s*1\)$/, ', 0)') } // 底部透明
        ]
      })

      // 目标配色
      const C1 = 'rgba(255, 200, 0, 1)' // 当日充值回本率
      const C2 = 'rgba(95, 225, 224, 1)' // 首充回本率
      const C3 = 'rgba(0, 141, 255, 1)' // 复充回本率

      return {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,0.7)',
          textStyle: { color: '#fff' },
          formatter(params) {
            const title = params?.[0]?.axisValue || ''
            let str = `${title}<br/>`
            params.forEach(item => {
              const val = Number(item.data)
              const n = Number.isFinite(val) ? val.toFixed(2) : '0.00'
              str += `${item.marker}${item.seriesName}：${n}%<br/>`
            })
            return str
          }
        },
        legend: {
          data: ['当日充值回本率', '首充回本率', '复充回本率'],
          top: 0,
          left: 10,
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          textStyle: { color: '#4E5969' }
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          top: 50, // 给右上角图例留空间
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: names,
          boundaryGap: false,
          axisLine: { lineStyle: { color: '#E0E0E0' }},
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLabel: { formatter: '{value}%' },
          splitLine: { lineStyle: { type: 'dashed', color: '#E0E0E0' }},
          axisTick: { show: false },
          axisLine: { show: false }
        },
        series: [
          {
            name: '当日充值回本率',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { width: 2, color: C1 },
            itemStyle: { color: C1, borderColor: '#fff', borderWidth: 1 },
            areaStyle: { color: gradientFrom(C1) },
            data: y1
          },
          {
            name: '首充回本率',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { width: 2, color: C2 },
            itemStyle: { color: C2, borderColor: '#fff', borderWidth: 1 },
            areaStyle: { color: gradientFrom(C2) },
            data: y2
          },
          {
            name: '复充回本率',
            type: 'line',
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { width: 2, color: C3 },
            itemStyle: { color: C3, borderColor: '#fff', borderWidth: 1 },
            areaStyle: { color: gradientFrom(C3) },
            data: y3
          }
        ]
      }
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 根据列名判断颜色
      if (column.property === 'date' || column.property === 'order_money' || column.property === 'account_recharge' || column.property === 'tcbi' || column.property === 'profitability') {
        return { background: '#F5F7FB' } // 橙色
      }
      return {}
    },
    headerCellStyle({ column, columnIndex }) {
      if (
        column.property === 'date' ||
        column.property === 'order_money' ||
        column.property === 'account_recharge' ||
        column.property === 'tcbi' ||
        column.property === 'profitability' ||
        columnIndex === 0
      ) {
        return { backgroundColor: '#F5F7FB' }
      }
      return { backgroundColor: '#F5F7FB' }
    },
    async querySearchAsync(queryString, cb) {
      const data = await getFictionList({ name: queryString || null })
      const newss = data.data.list.map((item) => {
        return {
          value: `${item.name} (${item.platform})`,
          address: item.id
        }
      })
      cb(newss)
    },
    handleSelect(item) {
      this.selectQueryData.novel_id = item.address
    },
    async oplistr() {
      const res = await commonreportoptions()
      this.optionstoufang = res.data.launch_platform_type
    }

  }
}
</script>

<style scoped lang="less">
.reportYear {
  // min-width: 1200px;
  // padding: 30px 60px;
  .titles {
      display: flex;
      align-items: center;
      padding-top:10px;
      padding-bottom:20px;
      font-weight:normal;
      label {
        padding: 5px 10px;
        border: 1px solid #eee;
      }
    }
  main {
    font-weight: 700;
    .form {
      display: flex;
      padding: 20px 0px;
      background: #fff;
      border-bottom: none;
      .form-top {
      width:100%;
      display: flex;
      justify-content: space-between;
      div {
        img {
          width: 16px;
          height: 16px;
          margin-right: 3px;
        }
      }
      .table-label {
        span {
          color: #86909c;
          font-weight:normal;
          margin-left: 10px;
        }
      }
    }
      .switch {
        color: #fff;
        position: absolute;
        top: 2px;
        left: 7px;
      }
      .aggregateData {
        margin-left: 20px;
        span {
          color: #9d2631;
        }
      }
    }
    .magRig {
      margin-right: 10px;
    }
    .magLfte {
      margin-left: 10px;
    }
  }
}
.el-card__body {
  .total-cell {
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right:1px solid rgba(231, 231, 231, 1);
    .total-img {
      img {
        width: 56px;
        height: 56px;
      }
    }
    .total-data {
      font-size: 18px;
      color: #1d2129;
      display: flex;
      flex-direction: column;
      height: 100%;
      margin-left: 10px;
      justify-content: space-between;

      div:nth-of-type(1) {
        font-size: 16px;
        color: #4e5969;
      }
      div:nth-of-type(2) {
        font-weight: bold;
      }
      span {
        font-size: 16px;
      }
    }
  }
  .total-cell:last-of-type{
    border-right:none;
  }
}
.total-box{
  margin: 10px 0px;
}
.chart-layout {
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* 上下左右间距统一 */
  background-color: #f1f2f5;
}
.chart-item {
  flex: 1 1 calc(50% - 16px); /* 每行两个，减去gap */
  height: 426px;
  padding: 20px;
  border-radius: 5px;
  background: #fff;
  box-sizing: border-box; /* 避免padding影响宽度计算 */
}
.blue{
  font-weight:bold;
}
</style>
